const GOOGLE_TO_AEMET_ICON = {
  CLEAR: '11',
  MOSTLY_CLEAR: '12',
  PARTLY_CLOUDY: '13',
  MOSTLY_CLOUDY: '15',
  CLOUDY: '16',
  WINDY: '12',
  FOGGY: '81',
  LIGHT_RAIN: '23',
  RAIN: '25',
  HEAVY_RAIN: '27',
  RAIN_SHOWERS: '24',
  DRIZZLE: '43',
  LIGHT_SNOW: '71',
  SNOW: '33',
  HEAVY_SNOW: '35',
  SNOW_SHOWERS: '34',
  SLEET: '36',
  HAIL: '36',
  THUNDERSTORM: '53',
  SCATTERED_THUNDERSTORMS: '53',
  LIGHT_RAIN_SHOWERS: '23',
  HEAVY_RAIN_SHOWERS: '27',
  CHANCE_OF_SHOWERS: '24',
  BLIZZARD: '35',
  ICE: '36',
};

// AEMET codes that have a night variant (suffix 'n')
const NIGHT_VARIANT_CODES = new Set([
  '11','12','13','14','15','16','17',
  '23','24','25','26','27',
  '33','34','35','36',
  '51','52','53','54',
  '61','62','63','64',
  '71','72','73','74',
  '81','82','83',
]);

/**
 * Resolves a weatherCode (Google string or AEMET numeric string) to the
 * AEMET icon code used for loading PNG assets. Applies night variant when
 * the hour period falls outside daylight hours (< 8 or >= 21).
 */
export function resolveWeatherIconCode(weatherCode, period) {
  if (!weatherCode) return '11';

  const base = GOOGLE_TO_AEMET_ICON[weatherCode] ?? (NIGHT_VARIANT_CODES.has(weatherCode) ? weatherCode : '11');

  if (period !== undefined && period !== null) {
    const hour = parseInt(period, 10);
    if (!isNaN(hour) && (hour < 8 || hour >= 21) && NIGHT_VARIANT_CODES.has(base)) {
      return `${base}n`;
    }
  }

  return base;
}
